module.exports = __webpack_public_path__ + "static/media/chat01.787cafc3.gif";